import {
  FILE_CONTEXTS,
  FILE_DATE_TAKEN_ASC_PARAM,
  FILE_DATE_TAKEN_DESC_PARAM,
  FILE_DEFAULT_SORT_OPTION,
  FILE_FILTERS,
  FILE_TYPES
} from '~/constants/files.js';

export const TIMELINE_FILE_SORT_PARAMS = Object.freeze([
  FILE_DATE_TAKEN_DESC_PARAM,
  FILE_DATE_TAKEN_ASC_PARAM
]);

export function getFileFilterPolicy(options = {}) {
  const {contextType, context} = options || {};
  const isTimelineContext = contextType === FILE_CONTEXTS.timeline;

  return {
    isTimelineContext,
    canUseOwnerFilters: isTimelineContext
      ? Boolean(context?.isOwnedByUser)
      : Boolean(!context || context.isOwnedByUser),
    canUseDateFilter: !isTimelineContext,
    allowedFileTypes: isTimelineContext
      ? Object.values(FILE_TYPES).filter(type => type !== FILE_TYPES.project)
      : null,
    allowedSortParams: isTimelineContext ? TIMELINE_FILE_SORT_PARAMS : null
  };
}

export function normalizeFileCollectionDescriptor(descriptor) {
  const policy = getFileFilterPolicy(descriptor);

  if (!policy.isTimelineContext) {
    return descriptor;
  }

  const order = policy.allowedSortParams.includes(descriptor.order?.paramName)
    ? descriptor.order
    : FILE_DEFAULT_SORT_OPTION;

  return {
    ...descriptor,
    order,
    albums: policy.canUseOwnerFilters ? (descriptor.albums || []) : [],
    tags: policy.canUseOwnerFilters ? (descriptor.tags || []) : [],
    people: policy.canUseOwnerFilters ? (descriptor.people || []) : [],
    fileTypes: descriptor.fileTypes?.filter(type => policy.allowedFileTypes.includes(type)) || [],
    organization: policy.canUseOwnerFilters
      ? descriptor.organization?.filter(type => [
          FILE_FILTERS.favorites,
          FILE_FILTERS.notInAlbum,
          FILE_FILTERS.notTagged
        ].includes(type)) || []
      : [],
    dateRange: null,
    scopeDateRange: null,
    scopeFileTypes: (descriptor.scopeFileTypes?.length
      ? descriptor.scopeFileTypes
      : policy.allowedFileTypes
    ).filter(type => policy.allowedFileTypes.includes(type)),
    projectsOnly: false
  };
}
